import { useCallback } from 'react';
import PingPongVideo from './PingPongVideo';

type Props = {
  imageSrc: string;
  imageAlt: string;
  videoSrc?: string;
  gifSrc?: string;
  imageError: boolean;
  touchActive: boolean;
  /** Desktop hover: родитель включает при mouseenter, выключает при leave */
  hoverActive: boolean;
  onImageError: () => void;
  onVideoActiveChange?: (active: boolean) => void;
};

/** Постер + ping-pong видео на hover (Mac) и tap (touch). */
export function CatalogCategoryMedia({
  imageSrc,
  imageAlt,
  videoSrc,
  gifSrc,
  imageError,
  touchActive,
  hoverActive,
  onImageError,
  onVideoActiveChange,
}: Props) {
  const videoActive = Boolean(videoSrc && (touchActive || hoverActive));

  const setActive = useCallback(
    (on: boolean) => {
      onVideoActiveChange?.(on);
    },
    [onVideoActiveChange],
  );

  return (
    <>
      {!imageError && (
        <img
          src={imageSrc}
          alt={imageAlt}
          className={`catalog-cat-poster w-full h-full object-cover absolute inset-0 z-0 transition-opacity duration-200 ${
            touchActive ? 'opacity-0' : ''
          }`}
          referrerPolicy="no-referrer"
          loading="lazy"
          decoding="async"
          onError={onImageError}
        />
      )}
      {imageError && (
        <div className="w-full h-full bg-gradient-to-br from-slate-700 to-slate-900 absolute inset-0 z-0" />
      )}
      {videoActive && (
        <PingPongVideo
          src={videoSrc!}
          poster={!imageError ? imageSrc : undefined}
          onPlayingChange={setActive}
          className="catalog-cat-hover-video w-full h-full object-cover absolute inset-0 z-[1] opacity-0 pointer-events-none transition-opacity duration-200"
        />
      )}
      {touchActive && gifSrc && !videoSrc && !imageError && (
        <img
          src={gifSrc}
          alt=""
          aria-hidden
          className="w-full h-full object-cover absolute inset-0 z-[1]"
          referrerPolicy="no-referrer"
        />
      )}
    </>
  );
}
